export default {
  popoverProviderr: {
    enter: {
      opacity: '0.01'
    },
    enterActive: {
      '@supports (transition: opacity 500ms ease-in)': {
        opacity: '1',
        WebkitTransition: 'opacity 500ms ease-in',
        OTransition: 'opacity 500ms ease-in',
        MsTransition: 'opacity 500ms ease-in',
        MozTransition: 'opacity 500ms ease-in',
        transition: 'opacity 500ms ease-in'
      }
    },
    leave: {
      opacity: '1'
    },
    leaveActive: {
      '@supports (transition: opacity 500ms ease-in)': {
        opacity: '0.01',
        WebkitTransition: 'opacity 500ms ease-in',
        OTransition: 'opacity 500ms ease-in',
        MsTransition: 'opacity 500ms ease-in',
        MozTransition: 'opacity 500ms ease-in',
        transition: 'opacity 500ms ease-in'
      }
    },
    enterDropdown: {
      '@supports (transition: 0.3s cubic-bezier(0,1,0.5,1))': {
        transform: 'translateY(-100%)',
        WebkitTransition: '0.3s cubic-bezier(0,1,0.5,1)',
        OTransition: '0.3s cubic-bezier(0,1,0.5,1)',
        MsTransition: '0.3s cubic-bezier(0,1,0.5,1)',
        MozTransition: '0.3s cubic-bezier(0,1,0.5,1)',
        transition: '0.3s cubic-bezier(0,1,0.5,1)'
      }
    },
    enterDropdownActive: {
      transform: 'translateY(0%)'
    },
    leaveDropdown: {
      '@supports (transition: 0.3s ease-in-out)': {
        transform: 'translateY(0%)',
        WebkitTransition: '0.3s ease-in-out',
        OTransition: '0.3s ease-in-out',
        MsTransition: '0.3s ease-in-out',
        MozTransition: '0.3s ease-in-out',
        transition: '0.3s ease-in-out'
      }
    },
    leaveDropdownActive: {
      transform: 'translateY(-100%)'
    }
  },
  notification: {
    errorNotification: {},
    notificationContainer: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      top: '0',
      "& $errorNotification": {
        display: "block",
        width: "80%",
        transition: "opacity 300ms ease-in",
        position: "relative",
        margin: "40px auto",
        background: "none repeat scroll 0 0 #FFE8DF",
        border: "1px solid #FD4B4E",
        borderRadius: "5px",
        color: "#FD4B4E",
        zIndex: "2147483647",
        maxWidth: "1180px",
        padding: "5px 10px",
      }
    }
  }
};
